export default __webpack_public_path__ + "static/media/Myimg.823a2b9b.png";